var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8288C15.9949 17.8268 14.459 18.4293 12.7807 18.4293C9.03582 18.4293 6 15.4296 6 11.7293C6 8.02899 9.03582 5.0293 12.7807 5.0293C14.459 5.0293 15.9949 5.63179 17.179 6.62984C18.363 5.63179 19.8989 5.0293 21.5773 5.0293C25.3221 5.0293 28.358 8.02899 28.358 11.7293C28.358 15.4296 25.3221 18.4293 21.5773 18.4293C19.8989 18.4293 18.363 17.8268 17.179 16.8288Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8288C18.6369 15.5999 19.5614 13.7713 19.5614 11.7293C19.5614 9.68734 18.6369 7.85874 17.179 6.62984C18.363 5.63179 19.8989 5.0293 21.5772 5.0293C25.3221 5.0293 28.3579 8.02899 28.3579 11.7293C28.3579 15.4296 25.3221 18.4293 21.5772 18.4293C19.8989 18.4293 18.363 17.8268 17.179 16.8288Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.179 16.8278C18.6369 15.5989 19.5614 13.7703 19.5614 11.7283C19.5614 9.6864 18.6369 7.85781 17.179 6.62891C15.7211 7.85781 14.7966 9.6864 14.7966 11.7283C14.7966 13.7703 15.7211 15.5989 17.179 16.8278Z",
    fill: "#FF5E00"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/MasterCard.8270369c0cf58d42b3dd0b043833df62.svg";
export { ForwardRef as ReactComponent };